import { render, staticRenderFns } from "./BeefCattleSmallList22023.vue?vue&type=template&id=4cd7b308&scoped=true"
import script from "./BeefCattleSmallList22023.vue?vue&type=script&lang=js"
export * from "./BeefCattleSmallList22023.vue?vue&type=script&lang=js"
import style0 from "./BeefCattleSmallList22023.vue?vue&type=style&index=0&id=4cd7b308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd7b308",
  null
  
)

export default component.exports